import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState, useRef } from 'react';
import _isNumber from 'lodash/isNumber';
import { FULL_SIZE_KEY } from './use-fixed-value-animation.constants';
import { getContentValueKey } from './use-fixed-value-animation.utils';
import { ANIMATION_STATUS, DEFAULT_ANIMATION_DELAY, DEFAULT_ANIMATION_DURATION } from '../../animation.constants';
import useAnimation from '../use-animation';
var ANIMATING = ANIMATION_STATUS.ANIMATING,
  NO_ANIMATION = ANIMATION_STATUS.NO_ANIMATION;
export default function useFixedValueAnimation(valueProp, contentRef, transition) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? DEFAULT_ANIMATION_DURATION : _ref$duration,
    _ref$fullSizeKey = _ref.fullSizeKey,
    fullSizeKey = _ref$fullSizeKey === void 0 ? FULL_SIZE_KEY : _ref$fullSizeKey;
  var timeoutId = useRef(null);
  var previousValue = useRef(null);
  function getValue() {
    if (_isNumber(valueProp) && valueProp < 0) {
      return 0;
    }
    return valueProp;
  }
  var _useState = useState(getValue()),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setCurrentValue = _useState2[1];
  var _useState3 = useState(valueProp === 0 ? 'hidden' : undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    overflow = _useState4[0],
    setOverflow = _useState4[1];
  var _useAnimation = useAnimation([transition], {
      duration: duration
    }),
    state = _useAnimation.state,
    startAnimation = _useAnimation.startAnimation;
  useEffect(function () {
    return function () {
      return clearTimeout(timeoutId.current);
    };
  }, []);
  var status = state.status;
  useEffect(function () {
    if (previousValue.current === null) {
      previousValue.current = valueProp;
    }
    startAnimation();
  }, [valueProp]);
  useEffect(function () {
    clearTimeout(timeoutId.current);
    var contentKey = getContentValueKey(transition);
    var contentFixedValue = contentRef.current[contentKey];
    var isPreviousFullSize = previousValue.current === fullSizeKey;
    var isFullSize = valueProp === fullSizeKey;
    if (status === ANIMATING) {
      setCurrentValue(isFullSize || isPreviousFullSize ? contentFixedValue : getValue());
      setOverflow('hidden');
      if (isPreviousFullSize) {
        timeoutId.current = setTimeout(function () {
          setCurrentValue(getValue());
        }, DEFAULT_ANIMATION_DELAY); // ensure no race condition between fixed value transitions
      }

      previousValue.current = valueProp;
    }
    if (status === NO_ANIMATION) {
      if (previousValue.current === valueProp) {
        // make sure to remove temporal content fixed value if any
        setCurrentValue(getValue());
      }
      if (valueProp === 0) {
        setOverflow('hidden');
      }
    }
  }, [status]);
  return {
    currentValue: currentValue,
    overflow: overflow,
    state: state,
    startAnimation: startAnimation
  };
}